<template>
  <section
    class="flex items-center min-h-[48px] py-1 relative overflow-x-hidden"
    :class="{
      'before:h-full before:bg-gradient-to-r before:w-24 before:from-transparent before:to-white before:absolute before:right-0 before:pointer-events-none':
        displayScrollArrowRight,
    }"
  >
    <div
      v-show="displayScrollArrowLeft"
      class="
        absolute
        min-h-[48px]
        py-1
        left-0
        w-24
        h-full
        bg-gradient-to-r
        to-transparent
        from-white
        pointer-events-none
      "
    />
    <section
      ref="categoryPicker"
      class="flex items-center gap-4 overflow-x-scroll scrollbar-hide"
    >
      <CategorySelector
        v-for="({ title, _uid, link }, index) in categories"
        :key="_uid"
        :position="index"
        :link="link"
        :animate-in="animated"
      >
        {{ title }}
      </CategorySelector>
    </section>
    <ArrowLongIcon
      v-if="displayScrollArrowRight"
      class="
        absolute
        right-0
        w-6
        hidden
        h-6
        cursor-pointer
        lg:block
        fill-black
        hover:fill-brandRed
      "
      @click="scrollRight"
    />
    <ArrowLongIcon
      v-if="displayScrollArrowLeft"
      class="
        absolute
        left-0
        w-6
        hidden
        h-6
        rotate-180
        cursor-pointer
        lg:block
        fill-black
        hover:fill-brandRed
      "
      @click="scrollLeft"
    />
  </section>
</template>
<script>
import CategorySelector from '~/components/category-selector/CategorySelector.vue'
// import ArrowRight from '~/assets/icons/chevron-right-large.svg'
import ArrowLongIcon from '~/static/images/arrow-long.svg'

export default {
  name: 'CategoryPickerSlideable',
  components: { CategorySelector, ArrowLongIcon },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    animated: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    displayScrollArrowRight: false,
    displayScrollArrowLeft: false,
  }),
  mounted() {
    this.$refs?.categoryPicker.addEventListener('scroll', this.handleScroll)
    this.displayScrollArrowRight =
      this.$refs?.categoryPicker?.scrollWidth > window?.innerWidth
  },
  methods: {
    scrollRight() {
      this.$refs.categoryPicker.scrollBy({
        left: 400,
        top: 0,
        behavior: 'smooth',
      })
    },
    scrollLeft() {
      this.$refs.categoryPicker.scrollBy({
        left: -400,
        top: 0,
        behavior: 'smooth',
      })
    },
    handleScroll(e) {
      const { scrollLeft, scrollWidth, clientWidth } = e.target
      this.displayScrollArrowRight =
        scrollWidth - (scrollLeft + 100) > clientWidth
      this.displayScrollArrowLeft = scrollLeft > 100
    },
  },
}
</script>
